module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_agder_neg.893004d4.svg";